import React from 'react';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../components/PublicLayout';
import './CommonPages.css';

const Careers = () => {
  const { t } = useTranslation();
  const email = t('careers.email', 'info@arcyintel.com');
  const subject = encodeURIComponent(t('careers.mailSubject', 'ArcVPN application'));
  const why = [
    { title: t('careers.whyFocusTitle'), body: t('careers.whyFocusBody') },
    { title: t('careers.whyOwnershipTitle'), body: t('careers.whyOwnershipBody') },
    { title: t('careers.whyFlexibilityTitle'), body: t('careers.whyFlexibilityBody') },
    { title: t('careers.whyLearningTitle'), body: t('careers.whyLearningBody') },
  ];

  return (
    <PublicLayout title={t('careers.title')} subtitle={t('careers.subtitle')}>
      <div className="common-page">
        <section className="arc-section" style={{ paddingTop: 0 }}>
          <div className="arc-section-head">
            <h2>{t('careers.whyTitle')}</h2>
          </div>
          <div className="arc-grid-2">
            {why.map((item) => (
              <article className="arc-panel" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="arc-section">
          <div className="arc-section-head">
            <h2>{t('careers.openTitle')}</h2>
          </div>
          <div className="arc-panel careers-empty">
            <h3>{t('careers.emptyTitle')}</h3>
            <p>{t('careers.emptyBody')}</p>
            <a className="arc-btn arc-btn-solid" href={`mailto:${email}?subject=${subject}`}>
              {t('careers.cta')}
            </a>
            <p className="careers-email">{email}</p>
          </div>
        </section>
      </div>
    </PublicLayout>
  );
};

export default Careers;
